import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import FUNNEL_CONSTANTS from "../constants";

export const StartFromFilter = () => {
  const dispatch = useDispatch();
  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom);

  return (
    <MultiSelectDropdown
      options={FUNNEL_CONSTANTS.START_FROM_OPTIONS}
      selectedFilters={startFrom}
      placeholder="Select Range"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (startFrom !== data) {
          dispatch(actionCreators.updateStartFrom(data));
        }
      }}
    />
  );
};
